import { PrivyProvider as PrivyAuthProvider } from '@privy-io/react-auth'
import type { ReactNode } from 'react'

interface PrivyProviderProps {
  children: ReactNode
}

export function PrivyProvider({ children }: PrivyProviderProps) {
  const appId = import.meta.env.VITE_PRIVY_APP_ID
  const clientId = import.meta.env.VITE_PRIVY_CLIENT_ID

  if (!appId) {
    throw new Error('VITE_PRIVY_APP_ID environment variable is required')
  }

  return (
    <PrivyAuthProvider
      appId={appId}
      clientId={clientId}
      config={{
        // SMS login configuration
        intl: {
          defaultCountry: 'US',
        },
        // Appearance to match app theme
        appearance: {
          theme: 'light',
          accentColor: '#111827', // --color-primary (main buttons)
          logo: '/logo.png',
          landingHeader: 'Welcome to Finch Pay',
          loginMessage: 'Sign in to continue',
        },
        // Only enable SMS login method
        loginMethods: ['sms'],
      }}
    >
      {children}
    </PrivyAuthProvider>
  )
}
